/**
 * Becker Orthopedic
 *
 * Landing area
 */

// Site specific SCSS
import "@/scss/landing.scss";

// jQuery
import $ from "jquery";
window.jQuery = $;
window.$ = $;

require("slick-carousel/slick/slick");

// Foundation
require("foundation-sites");
$(document).foundation();

/**
 * jQuery initialized
 */
$(function () {
	// Smooth scroll to anchor
	if (window.location.hash == "#contact") {
		document.getElementById("contact").scrollIntoView();
	}
	if (window.location.hash == "#form") {
		document.getElementById("form").scrollIntoView();
	}
});
